export default "__VITE_ASSET__C3C8xnKT__"